export default "__VITE_ASSET__BM1SLqtw__"